<script setup>
/* eslint-disable */
import { useRouter, useRoute } from 'vue-router';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useCouponsStore } from '@/stores/coupons';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useInitializeStore } from '@/stores/initialize';
import { useI18n } from 'vue-i18n';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import DayTimeSelector from '@/components/pre_sports/DayTimeSelector.vue';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const couponsStore = useCouponsStore();
const preSportsStore = usePreSportsStore();
const initializeStore = useInitializeStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

const popup_message = ref(false);
const isDropActive = ref(false);
const selectedText = ref(t('general.all'));
const show_scroll_to_top_button = ref(false);

const expand = () => {
	couponsStore.toggleAllExpanded();
}

const toggleDrop = () => {
	isDropActive.value = !isDropActive.value;
};

const selectOption = (text, action) => {
	selectedText.value = text;
	action();
	isDropActive.value = false;
};

const goToAllCoupons = () => {
	router.push({ name: 'pre-sports-coupons', params: { sport_id: preSportsStore.selectedPreSportId }});
}

const scrollToTop = () => {
	window.scrollTo({ top: 0 });
};

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};

onMounted(() => {
	let mini_layer = document.getElementById('mini-betslip-layer');
	if (mini_layer) {
		mini_layer.classList.add('hidden');
	}
	if (initializeStore.screen_width < 768) couponsStore.all_expanded = false;

	if (usePlatformConfigurationStore().isNewPreSportsLayoutEnabled) dateTimeSportFiltersStore.fetchUpcomingDaysInfo();
	window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
	let mini_layer = document.getElementById('mini-betslip-layer');
	if (mini_layer) {
		mini_layer.classList.remove('hidden');
	}
})
const goToNextHours = (hours) => {
	router.push({ name: 'pre-sports-coupons-next-hours', params: { sport_id: preSportsStore.selectedPreSportId, hours: hours }});
}

const goToCompetitions = () => {
	if (couponsStore.selectedCompetitionIds.length == 0) return;
	let competition_ids = couponsStore.selectedCompetitionIds.toString();

	router.push({ name: 'pre-sports-coupons-competitions', params: { sport_id: preSportsStore.selectedPreSportId, competition_ids: competition_ids}});
}

watch(() => couponsStore.selectedCompetitionIds.length, (newValue) => {
	popup_message.value = false;
	if (newValue > 40) popup_message.value = true;
	else popup_message.value = false;
})

watch(() => preSportsStore.selectedPreSportId, (newValue, oldValue) => {
	if (newValue != null && oldValue == null) {
		if (router.currentRoute.value.params.sport_id == '') {
			router.push( { name: 'pre-sports-coupons', params: { sport_id: preSportsStore.selectedPreSportId } } )
		}
	}
});

const showHigherScrollButton = computed(() => {
	if (initializeStore.screen_width < 768 && platformConfigurationStore.isNewPreSportsLayoutEnabled && couponsStore.selectedCompetitionIds.length > 0) return true;
	return false;
})

const clearSelection = () => {
	couponsStore.competition_ids = [];
}

const goToFilteredCompetitions = () => {
	let competition_ids = couponsStore.competition_ids.join(',');
	dateTimeSportFiltersStore.fetchUpcomingDaysInfo(competition_ids);

	const from = dateTimeSportFiltersStore.date_from ? dateTimeSportFiltersStore.date_from: 'all';

	router.push({ name: 'pre-sports-coupons-competitions-from-to', params: { sport_id: preSportsStore.selectedPreSportId, competition_ids: competition_ids, from: from, to: dateTimeSportFiltersStore.date_to } });
	// if (dateTimeSportFiltersStore.selected_option == 'all') {
	// 	goToCompetitions();
	// } else {
	// }
}

</script>

<template>
<div id="Coupons" class="">
	<div class="coupons-section-outer">

		<DayTimeSelector v-if="platformConfigurationStore.isNewPreSportsLayoutEnabled" />

		<div v-else class="coupon-section-header">
			<div class="tab">
				<button class="tablinks" @click="goToAllCoupons" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons'}">{{$t('general.all')}}</button>
				<button class="tablinks" @click="goToNextHours('3')" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '3'}">3 {{$t('general.hours')}}</button>
				<button class="tablinks" @click="goToNextHours('12')" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '12'}">12 {{$t('general.hours')}}</button>
				<button class="tablinks" @click="goToNextHours('24')" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '24'}">24 {{$t('general.hours')}}</button>
			</div>

			<!-- <div class="dashboard-info-label mobile-hours-dropdown">
				<div class="select-option">
					<dl class="drop" :class="{'active': isDropActive}">
						<span class="tabIco" @click="toggleDrop">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)"/>
								</g>
							</svg>
						</span>
						<dt @click="toggleDrop">
							<button class="tablinks">{{ selectedText }}</button>
						</dt>
						<dd v-if="isDropActive">
							<ul>
								<li>
									<button class="tablinks" @click="selectOption('All', goToAllCoupons)" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons'}">{{$t('general.all')}}</button>
								</li>
								<li>
									<button class="tablinks" @click="selectOption('3 Hours', () => goToNextHours('3'))" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '3'}">3 {{$t('general.hours')}}</button>
								</li>
								<li>
									<button class="tablinks" @click="selectOption('12 Hours', () => goToNextHours('12'))" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '12'}">12 {{$t('general.hours')}}</button>
								</li>
								<li>
									<button class="tablinks" @click="selectOption('24 Hours', () => goToNextHours('24'))" :class="{'active': router.currentRoute.value.name == 'pre-sports-coupons-next-hours' && router.currentRoute.value.params.hours == '24'}">24 {{$t('general.hours')}}</button>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div> -->

			<div class="show-coupons-btn" v-if="router.currentRoute.value.name == 'pre-sports-coupons'">
				<button class="btn-small colored-btn" @click="goToCompetitions" :disabled="isShowButtonDisabled">{{$t('general.show_lowercase')}}</button>
				<div v-if="popup_message" class="tooltip-main left">
					<div class="tooltip-inner">
						<p>{{$t('general.coupon_tooltip')}}</p>
					</div>
				</div>
			</div>

			<span class="toggle-markets" v-if="router.currentRoute.value.name == 'pre-sports-coupons'">
				<div @click="expand" class="markets-toggle-fill">
					<svg v-if="couponsStore.all_expanded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" svg-inline="" title="Toggle" role="presentation" focusable="false" xmlns:xlink="http://www.w3.org/1999/xlink" class="markets-toggle-svg">
						<use xlink:href="/assets/icons/markets_close.svg#markets_close"></use>
					</svg>
					<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" svg-inline="" title="Toggle" role="presentation" focusable="false" xmlns:xlink="http://www.w3.org/1999/xlink" class="markets-toggle-svg">
						<use xlink:href="/assets/icons/markets_open.svg#markets_open"></use>
					</svg>
				</div>
			</span>
		</div>

		<router-view></router-view>

	</div>
</div>
<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button" :style="showHigherScrollButton ? { bottom: '130px' } : { bottom: '70px' }">
	<i class="fas fa-arrow-up"></i>
</button>

<template v-if="platformConfigurationStore.isNewPreSportsLayoutEnabled">
	<Transition name="slide-up">
		<div v-if="couponsStore.getSelectedCompetionsFixturesCount > 0" class="quick-buttons-clear">
			<button class="btn btn-primary btn-clear" @click="clearSelection()">{{$t('general.clear')}}</button>
			<button class="btn btn-primary btn-show" @click="goToFilteredCompetitions()">{{$t('general.show_lowercase')}} ({{couponsStore.getSelectedCompetionsFixturesCount}})</button>
		</div>
	</Transition>
</template>

</template>
<style scoped>

.quick-buttons-clear {
	display: flex;
	justify-content: space-evenly;
	gap: 10px;
	padding: 12px 12px;
	background: var(--dark);
	position: fixed;
	bottom: 56px;
	z-index: 20;
	width: 100%;
	border-top: 1px solid var(--tab-gray);
}

.btn-show {
	background: var(--primary);
	border-color: var(--primary);
	padding: 7.5px 12px;
	border-radius: 4px;
	font-size: 14px;
	width: 40%;
	cursor: pointer;
	opacity: 1;
}

.btn-show:disabled {
	cursor: default;
	background: transparent;
	border-color: var(--tab-gray);
	opacity: 0.5;
}

.btn-clear {
	padding: 7.5px 12px;
	border-radius: 4px;
	font-size: 14px;
	width: 40%;
	cursor: pointer;
}

.btn-clear:hover {
	background: var(--secondary);
	border-color: var(--secondary);
}

.tooltip-main.left {
	left: -120px;
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}

html[dir="rtl"] .coupons-section-outer .coupon-section-header .show-coupons-btn {
	text-align: left;
	position: relative;
}

html[dir="rtl"] .tooltip-main.left {
	right: -120px;
	left: unset;
}

html[dir="rtl"] .tooltip-main.left:after {
	content: "";
	position: absolute;
	left: -3px;
	top: 50%;
	transform: translateY(-50%) rotate(44deg);
	width: 6px;
	height: 6px;
	background: var(--light-dark);
	border-left: 1px solid var(--tab-gray);
	border-right: unset;
	border-bottom: 1px solid var(--tab-gray);
	border-top: unset;
	right: unset;
}



.tooltip-main.left {
	left: -90px;
}

@media screen and (min-width: 320px) and (max-width: 320px) {
	.tooltip-main.left {
		left: -120px;
		top: 40%;
	}
	html[dir="rtl"] .tooltip-main.left {
		left: -130px;
		top: 40%;
	}
}

@media screen and (min-width: 375px) and (max-width: 500px) {
	.tooltip-main.left {
		left: -120px;
	}
}

@media screen and (min-width: 501px) and (max-width: 630px) {
	.tooltip-main.left {
		left: -100px;
	}
	html[dir="rtl"] .tooltip-main.left {
		left: unset;
		right: -100px;
	}
}

@media screen and (min-width: 631px) and (max-width: 767px) {
	.tooltip-main.left {
		left: -80px;
	}
}
@media screen and (min-width: 631px) and (max-width: 700px) {
	html[dir="rtl"] .tooltip-main.left {
		right: -80px;
		left: unset;
	}
}

@media screen and (min-width: 700px) and (max-width: 771px) {
	html[dir="rtl"] .tooltip-main.left {
		right: -70px;
		left: unset;
	}
}

@media screen and (min-width: 768px) and (max-width: 771px) {
	.tooltip-main.left {
		left: -60px;
	}
}

@media screen and (min-width: 772px) and (max-width: 1500px) {
	.tooltip-main.left {
		left: -130px;
	}
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
	.tooltip-main.left {
		left: -120px;
	}
	html[dir="rtl"] .tooltip-main.left {
		right: -120px;
		left: unset;
	}
}

@media screen and (min-width: 1701px) {
	.tooltip-main.left {
		left: -110px;
	}
	html[dir="rtl"] .tooltip-main.left {
		right: -110px;
		left: unset;
	}
}

.accordion-coupon {
	scrollbar-width: none !important;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.colored-btn:enabled {
	background: var(--secondary);
	border: 1px solid transparent;
	color: var(--buttons-text-color);
}
</style>